import React from 'react';
import {Link} from 'react-router-dom';

import {CheckBox} from '@pb/kit-component-checkbox';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Cell, Row} from '@pb/kit-component-table';

import {emailW, firstNameW, lastNameW, numberW, roleW, selectW, toolW, vendorW} from '../constants';

import {infoMessage} from './../access-management.module.styl';

import type {User} from 'src/openapi/admin/models/User';

type Props = {
    user: User,
    index: number,
    pageSize: number,
    currentPage: number,
    selected: boolean,
    onToggle: (checked: boolean, shiftKey: boolean) => void,
};

export const AccessManagementTableRow: React.FC<Props> = ({
    user,
    index,
    pageSize,
    currentPage,
    selected,
    onToggle,
}) => (
    <Row key={user.userId}>
        <Cell width={numberW}>{(currentPage - 1) * pageSize + index + 1}</Cell>
        <Cell className="text-align_center" width={selectW}>
            <CheckBox
                checked={selected}
                onCheckBoxChange={({event}: {event: React.ChangeEvent<HTMLInputElement>}) => {
                    const native = event.nativeEvent as MouseEvent | KeyboardEvent;
                    const shiftKey = Boolean(native?.shiftKey);
                    onToggle(event.target.checked, shiftKey);
                }}
                usePropsOnly={true}
            />
        </Cell>
        <Cell width={emailW}>
            <Link to={`/users/${user.userId}`} style={{display: 'block', maxWidth: '100%', textAlign: 'left'}}>
                <div style={{maxWidth: '100%'}}>
                    <EllipsisTextHint title={user.email}>
                        {user.email}
                    </EllipsisTextHint>
                </div>
            </Link>
        </Cell>
        <Cell width={firstNameW}>
            <EllipsisTextHint title={user.firstName}>{user.firstName}</EllipsisTextHint>
        </Cell>
        <Cell width={lastNameW}>
            <EllipsisTextHint title={user.lastName}>{user.lastName}</EllipsisTextHint>
        </Cell>
        <Cell width={vendorW}>
            {user.vendor ? (
                <Link to={`/vendors/${user.vendor.id}`}>
                    <EllipsisTextHint title={user.vendor.vendorName}>{user.vendor.vendorName}</EllipsisTextHint>
                </Link>
            ) : (
                <span className={infoMessage}>—</span>
            )}
        </Cell>
        <Cell width={roleW}>{user.role?.name || <span className={infoMessage}>—</span>}</Cell>
        <Cell width={toolW}>
            {user.tools?.length > 0 ? (
                <EllipsisTextHint title={user.tools.map(t => t.name).join(', ')}>
                    {user.tools.map(t => t.name).join(', ')}
                </EllipsisTextHint>
            ) : (
                <span className={infoMessage}>—</span>
            )}
        </Cell>
    </Row>
);
